import { Button, Paper } from '@mui/material';
import { AgCharts } from 'ag-charts-react';
import { colours } from '../../../StyleConstants';
import { useNavigate } from "react-router-dom";
import { useMemo } from 'react';
import "ag-charts-enterprise";

type Props = {
    data: any[];
    title: string;
    source?: string;
    ddAvailable: boolean;
    imagingData: any;
    eegData?: any;
    selectedSessionFilter?: string[];
    sessionInfoMap?: any;
    cohort?: boolean
}

const BarChart = ({ data, title, source, ddAvailable, imagingData, selectedSessionFilter, sessionInfoMap, eegData, cohort }: Props) => {
    const navigate = useNavigate()

    const maxNumber = useMemo((() => {
        return Math.max(...data.map((item) => item.value));
    }), data)

    const sessionFilteredRows = useMemo(() => {
        if (!selectedSessionFilter) return data;

        const set = new Set(selectedSessionFilter);
        return data.filter(row => set.has(row.label));
    }, [data, selectedSessionFilter])

    const eegLabels = useMemo(() => {
        return Object.keys(eegData || {}).reduce((acc: any, key) => {
            const title = eegData?.[key]?.title;
            if (title) {
                acc[title] = key;
            }
            return acc;
        }, {});
    }, [eegData]);

    const onClick = (() => {
        if (Object.keys(eegLabels).includes(title)) {
            navigate('/data-wrangler', { state: { dictSearch: eegLabels?.[title] } })
        } else {
            navigate('/data-wrangler', { state: { dictSearch: title } })
        }
    })

    return (
        <Paper
            elevation={5}
            sx={{
                marginBottom: 3,
                borderRadius: 1,
                padding: 1
            }}
        >
            <AgCharts
                style={{ height: "350px" }}
                key={title}
                options={{
                    title: {
                        text: title,
                        textAlign: 'left',
                        fontSize: 24,
                        fontWeight: 'bolder',
                        fontFamily: 'Libre Franklin',
                        spacing: 36,
                    },
                    data: sessionFilteredRows,
                    animation: {
                        enabled: true,
                    },
                    axes: [
                        {
                            type: "category",
                            position: "bottom",
                            label: { fontSize: 12, autoRotate: true, wrapping: cohort ? 'hyphenate' : 'on-space' },
                        },
                        {
                            type: "number",
                            position: "left",
                            label: { fontSize: 12 },
                            interval: { step: Math.round((maxNumber / 10) / 50) * 50 }
                        },

                    ],
                    series: [
                        {

                            type: "bar",
                            xKey: "label",
                            yKey: "value",

                            yName: "",
                            tooltip: {
                                range: 50,
                                renderer: ({ datum }) => {
                                    let heading = "";
                                    if (source) {
                                        heading += `Source: ${source}\n\n`;
                                    }
                                    heading += `${datum.label}\n`;
                                    if (sessionInfoMap[datum.label]?.description) {
                                        heading += sessionInfoMap[datum.label]?.description;
                                    }
                                    return {
                                        heading
                                    }
                                },
                            },
                            fill: colours.categorical.eight,

                        },
                    ],

                }}/>

            {ddAvailable && !Object.keys(imagingData).includes(title) &&
                <>
                    <Button
                        sx={{ margin: 2 }}
                        variant="outlined"
                        onClick={onClick}
                        onMouseDown={(e) => e.preventDefault()}
                    >
                        View Data Dictionary
                    </Button>
                </>}

        </Paper>
    )
}

export default BarChart;
